(() => {
  const pending = new WeakSet();
  function productForm(form) {
    return form && form.matches('form[data-type="add-to-cart-form"]') && form.closest('#MainContent');
  }
  async function add(form, button, variantId, quantity) {
    if (pending.has(form) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (!form.reportValidity()) return;
    pending.add(form);
    button.classList.add('is--loading');
    button.setAttribute('aria-disabled', 'true');
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const data = new FormData(form);
      if (variantId) data.set('id', variantId);
      if (quantity) data.set('quantity', quantity);
      data.set('sections', 'cart_data,mini_cart');
      data.set('sections_url', location.pathname);
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
        signal: controller.signal
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
      const theme = window.T4SThemeSP;
      if (theme?.Cart && result.sections?.cart_data && result.sections?.mini_cart) {
        theme.isATCSuccess = true;
        try { theme.Cart.renderContents(result.sections); }
        catch (error) { document.dispatchEvent(new CustomEvent('cart:refresh:opend')); }
      } else {
        location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      }
    } catch (error) {
      const message = error.name === 'AbortError' ? 'The request timed out. Please check your cart before trying again.' : error.message;
      if (window.T4SThemeSP?.Notices) window.T4SThemeSP.Notices(message);
      else window.alert(message);
    } finally {
      clearTimeout(timer);
      pending.delete(form);
      button.classList.remove('is--loading');
      button.removeAttribute('aria-disabled');
      button.querySelectorAll('.t4s-svg-spinner').forEach(spinner => spinner.setAttribute('hidden', ''));
    }
  }
  document.addEventListener('click', event => {
    const sticky = event.target.closest('.t4s-sticky-atc__atc[data-action-atc]');
    if (sticky) {
      const form = document.querySelector('#MainContent form.t4s-form__product[data-type="add-to-cart-form"]');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const quantity = sticky.parentElement.querySelector('[data-quantity-value]')?.value || '1';
      add(form, sticky, sticky.getAttribute('data-variant-id'), quantity);
      return;
    }
    const button = event.target.closest('[data-atc-form]');
    if (!button || !productForm(button.form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(button.form, button);
  }, true);
  document.addEventListener('submit', event => {
    if (!productForm(event.target)) return;
    const button = event.submitter || event.target.querySelector('[data-atc-form]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(event.target, button);
  }, true);
})();